import { ActionTree } from "vuex";
import { State } from "./Type";
// import API from "@/service/Api.service";

const actions: ActionTree<State, unknown> = {};

export default actions;
